import React from "react";
import PropTypes from "prop-types";
import { format } from "timeago.js";

const TimeAgo = ({ children, ...props }) => {
  const dateString = new Date(children).toLocaleString();
  return (
    <span title={dateString} {...props}>
      {format(children)}
    </span>
  );
};

TimeAgo.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date)
  ]).isRequired
};

export default TimeAgo;
